var Button          = require("../Button"),
    $               = require("jquery"),
    itemTemplate    = require("./item.ejs");


var LayerSwitcher = Button.extend({

    options: {
        showCurrIndicator: true,
        currIndicatorPosition: 'right'
    },

    /**
     *
     * @param options
     */
    initialize: function(options) {
        var that = this,
            indicatorPos = 'pos-right';

        that._layerList = [];
        that._switcherCont = undefined;
        that._baseLayer = undefined;

        LayerSwitcher.__super__.initialize.call(that, options);

        that.getContainer().addClass('button-layers layer-switcher');

        that.getContainer().on('change', 'input', function(event){
            if ($(this).prop('type') == "checkbox") {
                if (that._baseLayer.cdr_layer) {
                    if ($(this).prop('checked') == true) {
                        that._baseLayer.cdr_layer.setVisible(true);
                    } else {
                        that._baseLayer.cdr_layer.setVisible(false);
                        if (that._baseLayer.cdr_highlight_layer) {

                            that._baseLayer.cdr_highlight_layer.getSource().emptyCache();
                            that._baseLayer.cdr_zouit_highlight_layer.getSource().emptyCache();

                            that._baseLayer.cdr_highlight_layer.setVisible(false);
                            that._baseLayer.cdr_zouit_highlight_layer.setVisible(false);
                            
                        }
                    }
                }
            } else {
                that.view.switchBaseLayer($(this).data('layer'));
            }
        });

        if (that.options.showCurrIndicator) {
            indicatorPos = that.options.currIndicatorPosition == 'left'
                ? 'pos-left'
                : 'pos-right';

            that.currLayerIndicator = $('<div></div>');
            that.currLayerIndicator.addClass('curr-layer-label '+indicatorPos);
            that.getContainer().append(that.currLayerIndicator);
        }
    },

    /**
     *
     * @param view
     */
    onAdd: function(view){
        var that = this;

        that.view = view;

        that._baseLayer = view.getBaseLayer();
        that._layerList = view.options.publication['base_maps'];
        
        if(that._layerList.length == 0) {
            that.getContainer().hide();
            return;
        }

        that._createSwitcher();
        that._baseLayer.on('layerChanged', function(event){
            that._switcherCont.find('input[data-layer='+event.layerName+']').prop('checked', true);
            that.setIndicator(event.layerName);
        });
    },

    /**
     *
     * @private
     */
    _createSwitcher: function(){
        var that = this,
            currBase    = false,
            cadastreOn  = false,
            layerList   = {},
            lng,
            names,
            name;

        that._layerList.forEach(function(el, i){
            // возможно название локализовано
            // [{ru: Название}, {en: Name]
            lng = that.view.getProject().lng;
            name = '';
            if (el.localized_name && lng) {
                names = el.names.filter(function(n) {
                    return lng in n;
                }).map(function (n) {
                    return n[lng];
                });
                if (names.length) {
                    name = names[0];
                }
            }
            layerList[el.id] = {};
            layerList[el.id].name = el.localized_name && lng ? name : el.name;
            layerList[el.id].value = el.value == "cadastre" ? el.value : '';
            if (el.selected && el.value != "cadastre" && !currBase) {
                currBase = el.id;
            }
            if (el.selected && el.value == "cadastre") {
                cadastreOn = el.id;
            }
        });

        that._switcherCont = $(itemTemplate({
            layers: layerList
        }));

        // включаем ПКК, если она активна
        if (cadastreOn) {
            that._switcherCont.find('input[data-layer='+cadastreOn+']').prop('checked', true); 
            that._baseLayer.cdr_layer.setVisible(true);
        }

        that._switcherCont.find('input[data-layer='+currBase+']').prop('checked', true);
        that._switcherCont.appendTo(that.getContainer());
        that.setIndicator(currBase);
    },

    setIndicator: function(layerName) {
        var that = this,
            html;

        if (that.options.showCurrIndicator) {
            html = that._switcherCont.find('label[for="omjs_lsw_'+layerName+'"]').html();
            that.currLayerIndicator.html(html);
        }
    },

    enableCadastreLayer: function(state) {
        var that = this;
        state = state === undefined ? true : state;
        var $input = that.getContainer().find('input[data-cadastre]');
        $input.prop('checked', !!state);
        $input.trigger('change');
    }
});

module.exports = LayerSwitcher;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/LayerSwitcher/LayerSwitcher.js
// module id = 203
// module chunks = 0